import { Pipe, PipeTransform } from '@angular/core';
import {Skuska} from './model/skuska';

@Pipe({
    name: 'filterPredmetPipe',
    standalone: false
})
export class FilterPredmetPipePipe implements PipeTransform {

  transform(value: Skuska[], input: string, kdeSomPrihlaseny: boolean, kdeSaMozemPrihlasit: boolean): Skuska[]
  {
    let skusky = value;

    if (input) {
      skusky = value.filter((s) => {
        if (s.predmetNazov.toUpperCase().indexOf(input.toUpperCase()) >= 0) {
          return true;
        }
        if (s.predmetSkratka.toUpperCase().indexOf(input.toUpperCase()) >= 0) {
          return true;
        }

        return s.search.indexOf(input.toUpperCase()) >= 0;
      });
    }

    skusky = skusky.filter((s: Skuska) => {
        return (
            kdeSaMozemPrihlasit && s.bude && !s.terminNaplneny
                && (s.hodnoteniePredmet === null || s.mozeSaPrihlasit) && s.hodnotenieTermin === null
            ) ||
            (kdeSomPrihlaseny && s.datumPrihlasenia !== null) ||
            (!kdeSaMozemPrihlasit && !kdeSomPrihlaseny);
      });

    return skusky;
  }

}
